var option_shark_flipbook = {
    height: '100vh',
    backgroundColor: '#c5a47e10',
    duration: 800,
    webgl: true,
    soundEnable: false,
    pageMode: DFLIP.PAGE_MODE.AUTO,
    duration: 600,
    autoEnable: true,
    autoplay: false,
    scrollWheel: false,
    sound: true,
    forceFit: true,
};

/* Custom Sayfaya Git Baş */
jQuery(function ($) {
    $(document).on('click', '.df-goto', function (e) {
        e.preventDefault();

        var type = this.dataset.target;
        var value = this.dataset.value;

        var book = window.shark_flipbook
            || document.getElementById('shark_flipbook')?.dflip;

        if (!book) return;

        if (type === 'page') {
            var p = parseInt(value, 10);
            if (Number.isFinite(p)) {
                var max = book.contentProvider?.pageCount || p;
                p = Math.min(Math.max(p, 1), max);
                book.gotoPage(p);
            }
        } else if (type === 'dest' && value) {
            var ls = book.contentProvider && book.contentProvider.linkService;
            if (ls && ls.customNavigateTo) {
                ls.customNavigateTo(value);
            } else {
                var asNum = parseInt(value, 10);
                if (Number.isFinite(asNum)) book.gotoPage(asNum);
            }
        }
    });
});
/* Custom Sayfaya Git Son */